import { render, staticRenderFns } from "./DiscoveryList.vue?vue&type=template&id=739517ec&scoped=true&"
import script from "./DiscoveryList.vue?vue&type=script&lang=js&"
export * from "./DiscoveryList.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryList.vue?vue&type=style&index=0&id=739517ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739517ec",
  null
  
)

export default component.exports